exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.fs-uberhuge[data-v-bad3bfac] {\n  font-size: 2.5rem;\n}\n.panel[data-v-bad3bfac] {\n  height: 118px !important;\n  padding: 1rem;\n}\n.feed .feedItem[data-v-bad3bfac] {\n  height: auto;\n}\n.singleCard[data-v-bad3bfac] {\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  margin-left: 15px;\n  margin-top: 0;\n}\n.singleCard[data-v-bad3bfac]:first-child {\n    margin-left: 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-bad3bfac","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/FeedcardMulti.vue
// module id = 2416
// module chunks = 0